
export default {
  components: {
    hotNewHeroLeft: () => import('~/components/Organisms/NewHeroLeft/NewHeroLeft.vue'),
    OrganicModal: () => import('~/components/Molecules/Organic/Modal/Modal.vue'),
    hotCountersV2: () => import('~/components/Organisms/Counters-v2/Counters-v2.vue'),
    hotContentSection: () => import('~/components/Organisms/ContentSection/ContentSection.vue'),
    hotOurHistory: () => import('~/components/Organisms/OurHistory/OurHistory.vue'),
    hotAboutActions: () => import('~/components/Organisms/AboutActions/AboutActions.vue'),
  },

  computed: {
    isPortuguese() {
      return Boolean(['pt-br'].includes(this.$i18n.locale))
    },
  },
}
